import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { GeneralService } from './services/general.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public lastURLprefered 
  constructor(public generalService: GeneralService, private router: Router) {
    this.generalService.translate.addLangs(['en', 'fr', 'ar']);
    this.generalService.translate.setDefaultLang('fr');
    this.getInitDoc();
    this.getUserPerso();
  }

  title = 'AVT-tim';

  getUserPerso() {
    if (
      this.generalService.isNotEmpty(this.generalService.collaborateurConnecter)
    )
      this.generalService
        .rechercheTable(
          this.generalService.url +
            'UserPerso&param=' +
            this.generalService.collaborateurConnecter
        )
        .subscribe((userPerso) => {
          if (userPerso.length > 0)
            this.generalService.userPerso = userPerso[0];
        });
    else
      setTimeout(() => {
        this.getUserPerso();
      }, 100);
  }
  getInitDoc() {
    this.generalService
      .rechercheTable('ds/ajout?dstables=files')
      .subscribe((initDoc) => {
        this.generalService.initDoc = initDoc;
      });
    return '';
  }
  ngOnInit() {
    
    this.router.events.subscribe((event) => {
        if (event instanceof NavigationCancel ){
            console.log(event.url);
            this.lastURLprefered = event.url    
            localStorage.setItem("lastURLprefered",this.lastURLprefered)
        
        }
  });
    // localStorage.getItem('lastVisitedRoute')
    // this.router.events.subscribe((event) => {
    //   if (
    //     event instanceof NavigationEnd &&
    //     event.url != '/avt/home' &&
    //     event.url != '/' &&
    //     event.url != '/login'
    //   ) {
    //     // console.log(event.url);
    //     // localStorage.setItem('lastVisitedRoute', event.url);
    //   }
    // });
  }
}
